import * as React from "react"

import { App } from "./app"
import { ToolbarButton } from "./ToolbarButton"
import { PADebug } from "./PADebug"

///////////////   SearchSettingsView  ////////////////

/* ProjectView displays all projects saved by the logged in user and makes them accessible
   by a load button, and as well lets the user merge a saved project into the current one. */

export interface SearchSettingsViewVm  {
    app: App
}

export interface SearchSettingsViewStateVm {
    stage: string
}

export function GetAuto() {
    const screenY = window.innerHeight
    var ideal = (((screenY - 250) * 2.13) / 100) + 0.5
    
    ideal = ideal - (ideal % 1)

    if ((ideal < 1) || (ideal > 1000)) {
        ideal = 25
        PADebug.Assert(false, "SettingsView.OnAuto - result of hits per page calculation became unexpectedly high or low and was replaced by the value 25.")
        PADebug.Log("SettingsView.OnAuto - result:" + ideal.toString() + " ScreenY:" + screenY.toString())
    }

    return ideal
} 

export class SearchSettingsView extends React.Component<SearchSettingsViewVm, SearchSettingsViewStateVm> {

    constructor(props: SearchSettingsViewVm) {
        super(props)
        this.m_hoveredRadioIndex = -1
    }

    // 
    state = {
        stage: "initial"
    }

    // Initiating the handle back to this freshest instance of a SearchSettingsView for updates
    componentWillMount() {
        this.props.app.GetCore().ConnectSearchSettingsView(this)
    }

    OnClickRadio01() {
        this.m_hoveredRadioIndex = -1
        this.props.app.setState({ cathegoricSearch: false })
        this.forceUpdate()
    }

    OnClickRadio02() {
        this.m_hoveredRadioIndex = -1
        this.props.app.setState({ cathegoricSearch: true })
        this.forceUpdate()
    }

    OnEnterRadio01() {
        this.m_hoveredRadioIndex = 0
        this.forceUpdate()
    }

    OnEnterRadio02() {
        this.m_hoveredRadioIndex = 1
        this.forceUpdate()
    }

    OnExitRadioButtons() {
        this.m_hoveredRadioIndex = -1
        this.forceUpdate()
    }
    
    
    //  
    render() { 
        const core = this.props.app.GetCore() 
        const margin_Left = "33px"
        const margin_Mid = "13px"

        const checkedPos = "0px 0px"
        const uncheckedPos = "-25px 0px"

        const checkWidth = "25px"
        const checkHeight = "25px"
        const itemHeight = "40px"
        const marginTextTop = "5px"

        const bgFile = "url(images/searchSettingsGraphics.png)"

        var flags = this.props.app.GetCore().GetFilterFlags()
        
        var imgPos_description1 = ((flags & 1) != 0) ? checkedPos : uncheckedPos
        var imgPos_description2 = ((flags & 2) != 0) ? checkedPos : uncheckedPos
        var imgPos_ID = ((flags & 4) != 0) ? checkedPos : uncheckedPos
        var imgPos_nobb = ((flags & 8) != 0) ? checkedPos : uncheckedPos
        var imgPos_nobbEier = ((flags & 16) != 0) ? checkedPos : uncheckedPos
        var imgPos_eanNo = ((flags & 32) != 0) ? checkedPos : uncheckedPos
        var imgPos_cathTitle = ((flags & 64) != 0) ? checkedPos : uncheckedPos

        const radioUncheckedPos = "0px -136px"
        const radioHoverPos = "0px -172px"
        const radioCheckedPos = "0px -154px"
        
        var radio01Pos = radioUncheckedPos
        var radio02Pos = radioUncheckedPos

        if (this.m_hoveredRadioIndex == 0) {
            radio01Pos = radioHoverPos
        }

        if (this.m_hoveredRadioIndex == 1) {
            radio02Pos = radioHoverPos
        }

        if (this.props.app.state.cathegoricSearch) {
            radio02Pos = radioCheckedPos
        }
        else {
            radio01Pos = radioCheckedPos
        }
  
        return <div> 
            {/* Top margin: */}  
            <div style={{height:"19px", width:"100%"}}>  
            </div> 
             
            {/* Title: */} 
            <div style={{ height: "52px", fontSize: "28px", fontWeight: "bold", marginLeft: margin_Left }}>
                Søk instillinger:
            </div> 

            <div style={{ height: "40px", fontSize: "18px", fontWeight: "bold", marginLeft: margin_Left }}>
                Kilde:
            </div> 

            {/* Kilde alterativer: */}
            <div style={{ width: "calc(100% - 66px)", maxWidth: "225px", height: "72px", fontSize: "28px", fontWeight: "bold", marginLeft: margin_Left, backgroundColor: "#EAF3FF" }}
                onMouseLeave={(e) => this.OnExitRadioButtons()}>
                <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "8px", left: "7px" }}
                    onClick={(e) => this.OnClickRadio01()}
                    onMouseEnter={(e) => this.OnEnterRadio01()}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: radio01Pos, width: "16px", height: "18px", position: "relative", top: "3px" }}></div>
                    <div style={{ fontWeight: "normal", marginLeft: "10px", height: "25px", marginTop: "5px" }}> Søk innen alle varegrupper </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", position: "relative", top: "8px", left: "7px" }}
                    onClick={(e) => this.OnClickRadio02()}
                    onMouseEnter={(e) => this.OnEnterRadio02()}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: radio02Pos, width: "16px", height: "18px", position: "relative", top: "3px" }}></div>
                    <div style={{ fontWeight: "normal", marginLeft: "10px", height: "25px", marginTop: "5px" }}> Søk innen valgt varegruppe </div>
                </div>
            </div>

            {/* Filtrerings alternativer (checkboxes) */}

            <div style={{ height: "40px", fontSize: "18px", fontWeight: "bold", marginLeft: margin_Left, marginTop: "30px" }}>
                Filtrering:
            </div> 

            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_description1, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("desc1")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk i varetekst 1 (øvre raden)
                </div>
            </div>
            
            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_description2, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("desc2")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk i varetekst 2 (nedre raden)
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_ID, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("ID")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk ID nummer
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_nobb, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("nobb")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk nobb nummer
                </div>
            </div>
            
            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_nobbEier, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("nobbOwner")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk nobb eier nummer
                </div>
            </div>
            
            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_eanNo, width: checkWidth, height: checkHeight }} onClick={ (e) => this.OnCheckClick("eanNo") }></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk ean nummer
                </div>
            </div>
            
            <div style={{ display: "flex", flexDirection: "row", height: itemHeight }}>
                <div style={{ width: margin_Left }}></div>
                <div style={{ backgroundImage: bgFile, backgroundPosition: imgPos_cathTitle, width: checkWidth, height: checkHeight }} onClick={(e) => this.OnCheckClick("cathTitle")}></div>
                <div style={{ marginLeft: margin_Mid, marginTop: marginTextTop }}>Søk varegruppe
                </div>
            </div>

            {/* Space */}
            <div style={{ height: "20" }}></div> {}

            <div style={{ marginLeft: margin_Left, marginTop: "8px", display: "flex", direction: "row" }}>
                <div style={{ height: "40px", fontSize: "18px", fontWeight: "bold", position:"relative", top:"5px" }}>
                    Antall søketreff per side: {this.props.app.state.resultGroupLength}
                </div> 
                
                <div onClick={this.OnMinus.bind(this)} style={{ cursor: "pointer", width: "29px", height: "31px", textAlign: "center", backgroundColor: "#EEEEEE", marginLeft: "16px" }}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: "-38px -198px", width: "20px", height: "20px", position: "relative", top: "4px", left: "4px" }}>
                    </div>
                </div>

                <div onClick={this.OnPlus.bind(this)} style={{ cursor: "pointer", width: "29px", height: "31px", textAlign: "center", backgroundColor: "#EEEEEE", marginLeft: "5px" }}>
                    <div style={{ backgroundImage: "url(images/UtvidetInfoTab.png)", backgroundPosition: "-4px -198px", width: "20px", height: "20px", position: "relative", top: "4px", left: "4px" }}>
                    </div>
                </div>
            </div>

            {/* Space */}
            <div style={{ height: "8px" }}></div> {}

            <div style={{ display: "flex", direction: "row", marginLeft: margin_Left, marginTop: "8px" }}>
                {/*<ToolbarButton app={this.props.app} imageNR={27} buttonID="10treffer" tooltipText="10 treffer per side" />
                <div style={{ width: "20px" }}></div> */}
                <ToolbarButton app={this.props.app} imageNR={28} buttonID="15treffer" tooltipText="15 treffer per side" />
                <div style={{ width: "20px" }}></div>
                <ToolbarButton app={this.props.app} imageNR={29} buttonID="20treffer" tooltipText="20 treffer per side" />
                <div style={{ width: "20px" }}></div>
                <ToolbarButton app={this.props.app} imageNR={18} buttonID="25treffer" tooltipText="25 treffer per side" />
                <div style={{ width: "20px" }}></div>
                <ToolbarButton app={this.props.app} imageNR={19} buttonID="50treffer" tooltipText="50 treffer per side" />
                <div style={{ width: "20px" }}></div>
                <ToolbarButton app={this.props.app} imageNR={20} buttonID="100treffer" tooltipText="100 treffer per side" />
                <div style={{ width: "22px" }}></div>
                <div onClick={this.OnAuto.bind(this)} style={{ cursor: "pointer", width: "90px", height: "31px", textAlign: "center", backgroundColor: "#EEEEEE", marginLeft: "5px" }}>
                    <div style={{ width: "90px", height: "20px", position: "relative", top: "8px", left: "1px", fontWeight:"bold" }}>Auto:{GetAuto().toString()}
                    </div>
                </div>
            </div>
        </div> 
    }

    OnCheckClick(clickedItem: string) {
        var previousFlags = this.props.app.GetCore().GetFilterFlags()

        if (clickedItem == "desc1") {
            if ((previousFlags & 1) != 0) {
                previousFlags = previousFlags & (2 | 4 | 8 | 16 | 32 | 64)
            }
            else {
                previousFlags = previousFlags | 1
            }
        }
        
        if (clickedItem == "desc2") {
            if ((previousFlags & 2) != 0) {
                previousFlags = previousFlags & (1 | 4 | 8 | 16 | 32 | 64)
            }
            else {
                previousFlags = previousFlags | 2
            }
        }

        if (clickedItem == "ID") {
            if ((previousFlags & 4) != 0) {
                previousFlags = previousFlags & (1 | 2 | 8 | 16 | 32 | 64)
            }
            else {
                previousFlags = previousFlags | 4
            }
        }

        if (clickedItem == "nobb") {
            if ((previousFlags & 8) != 0) {
                previousFlags = previousFlags & (1 | 2 | 4 | 16 | 32 | 64)
            }
            else {
                previousFlags = previousFlags | 8
            }
        }

        if (clickedItem == "nobbOwner") {
            if ((previousFlags & 16) != 0) {
                previousFlags = previousFlags & (1 | 2 | 4 | 8 | 32 | 64)
            }
            else {
                previousFlags = previousFlags | 16
            }
        }

        if (clickedItem == "eanNo") {
            if ((previousFlags & 32) != 0) {
                previousFlags = previousFlags & (1 | 2 | 4 | 8 | 16 | 64)
            }
            else {
                previousFlags = previousFlags | 32
            }
        }

        if (clickedItem == "cathTitle") {
            if ((previousFlags & 64) != 0) {
                previousFlags = previousFlags & (1 | 2 | 4 | 8 | 16 | 32)
            }
            else {
                previousFlags = previousFlags | 64
            }
        }
        
        this.props.app.GetCore().SetFilterFlags(previousFlags)
        this.forceUpdate()
    }

    OnPlus() {
        var len = this.props.app.state.resultGroupLength

        this.props.app.setState({ resultGroupLength: len + 1 })
    }

    OnMinus() {
        var len = this.props.app.state.resultGroupLength

        if (len >= 2) {
            this.props.app.setState({ resultGroupLength: len - 1 })
        }
    }

    // Handler for click on automatic calculation of hits per page
    OnAuto() {
        this.props.app.setState({ resultGroupLength: GetAuto() })
    }
    
    private m_hoveredRadioIndex: number
}



// WEBPACK FOOTER //
// ./client/view/SearchSettingsView.tsx